import { z } from "zod";
import type { ParserKey, TriggerIngestionRequest } from "@noa/api-core";

// Left empty, each file goes to the parser for its format (Markdown and text
// included), which suits a Drive folder that mixes PDFs and notes.
export const PARSER_OPTIONS: { value: ParserKey; label: string }[] = [
  { value: "PDF_FAST", label: "PDF Fast (text docs)" },
  { value: "PDF", label: "PDF (Docling)" },
  { value: "DESCRIPTION", label: "Description (rich chunk)" },
  { value: "MARKDOWN", label: "Markdown" },
  { value: "TXT", label: "Text" },
];

// A Select cleared with its "×" reports `undefined`, not `null`: `.nullish()` accepts both,
// where `.nullable()` made the form invalid and the sync button silently inert.
export const googleDriveSyncSchema = z.object({
  folder: z.string().nullish(),
  schemaId: z.string().nullish(),
  parser: z.enum(["PDF", "PDF_FAST", "DOCX", "HTML", "TXT", "MARKDOWN", "IMAGE", "DESCRIPTION"]).nullish(),
  withVision: z.boolean(),
  skipExisting: z.boolean(),
  limitEnabled: z.boolean(),
  maxRecords: z.number().int().min(1).max(10000),
});

export type GoogleDriveSyncForm = z.infer<typeof googleDriveSyncSchema>;

export const googleDriveSyncDefaultValues: GoogleDriveSyncForm = {
  folder: null,
  schemaId: null,
  parser: null,
  withVision: true,
  skipExisting: true,
  limitEnabled: false,
  maxRecords: 10,
};

/** The trigger request for a sync: an unset folder, schema or parser means "all" / "auto". */
export function buildGoogleDriveSyncRequest(values: GoogleDriveSyncForm): TriggerIngestionRequest {
  return {
    files: ["*"],
    source_type: "google_drive",
    folder: values.folder || undefined,
    schema_id: values.schemaId || undefined,
    parser: values.parser || undefined,
    with_vision: values.withVision,
    skip_existing: values.skipExisting,
    max_records: values.limitEnabled ? values.maxRecords : undefined,
  };
}
